module.exports = __webpack_public_path__ + "static/img/menuRysuj-OFF.b11ab24c.png";